import type { PipelineRun, RunDeliveryStatus } from "../lib/api";

const statusClassName: Record<PipelineRun["status"], string> = {
  RUNNING: "border-info/25 bg-info/10 text-info",
  DONE: "border-primary/25 bg-primary/10 text-primary",
  SKIPPED: "border-warning/35 bg-warning/15 text-warning-foreground",
  FAILED: "border-danger/25 bg-danger/10 text-danger",
};

const statusLabel: Record<PipelineRun["status"], string> = {
  RUNNING: "В работе",
  DONE: "Готово",
  SKIPPED: "Пропущено",
  FAILED: "Ошибка",
};

export function StatusBadge({ status }: { status: PipelineRun["status"] }) {
  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${statusClassName[status]}`}
    >
      {statusLabel[status]}
    </span>
  );
}

const deliveryClassName: Record<RunDeliveryStatus, string> = {
  NOT_STARTED: "border-border bg-muted text-muted-foreground",
  PENDING: "border-info/25 bg-info/10 text-info",
  ACCEPTED: "border-info/25 bg-info/10 text-info",
  SENT: "border-primary/25 bg-primary/10 text-primary",
  DELIVERED: "border-primary/25 bg-primary/10 text-primary",
  READ: "border-primary/25 bg-primary/10 text-primary",
  UNKNOWN: "border-warning/35 bg-warning/15 text-warning-foreground",
  FAILED: "border-danger/25 bg-danger/10 text-danger",
};

export function DeliveryStatusBadge({
  status,
  label,
}: {
  status: RunDeliveryStatus;
  label: string;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${deliveryClassName[status]}`}
    >
      {label}
    </span>
  );
}

export function EventLevelBadge({
  level,
}: {
  level: "INFO" | "WARN" | "ERROR";
}) {
  const className =
    level === "ERROR"
      ? "border-danger/25 bg-danger/10 text-danger"
      : level === "WARN"
        ? "border-warning/35 bg-warning/15 text-warning-foreground"
        : "border-primary/20 bg-primary/10 text-primary";

  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${className}`}
    >
      {level}
    </span>
  );
}
